
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.318 2.681a.625.625 0 00-.656-.143l-13.75 5a.625.625 0 000 1.168l5.369 2.144 3.962-3.975.882.881-3.982 3.982 2.15 5.368a.625.625 0 00.582.394.625.625 0 00.575-.413l5-13.75a.624.624 0 00-.132-.656z","fill":"#fff"}})])
          )
        }
      }
    